// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Zq-z","slideIn":"_q-z"};